import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [{
    path: '/',
    component: () => import('../components/datav/index.vue'),
    redirect: '/index',
    meta: {
      title: '首页'
    }
  },
  {
    path: '/index',
    component: () => import('../components/datav/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/notice',
    component: () => import('../view/notice.vue'),
    meta: {
      title: '通告'
    }
  },
  {
    path: '/interaction',
    component: () => import('../view/interaction/index.vue'),
    meta: {
      title: '互动栏'
    }
  },
  {
    path: '/login',
    component: () => import('../view/login/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/test',
    component: () => import('../view/test.vue'),
    meta: {
      title: '测试'
    }
  },
  {
    path: '/webview',
    component: () => import('../view/webview.vue'),
    meta: {
      title: ''
    }
  }

]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
